/* CL CARD - limita las badges de features a 2 líneas reales y agrega un badge "+" cuando sobran */
(function () {
  function distinctTops(els) {
    var s = new Set();
    els.forEach(function (e) { if (e.offsetParent !== null) s.add(e.offsetTop); });
    return s.size;
  }

  function clamp(list) {
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('li:not(.cl-feature-more)'))
      .filter(function (li) { return li.textContent.trim() !== ''; });

    // reset: mostrar todo y quitar "+" previo
    items.forEach(function (li) { li.style.display = ''; });
    var more = list.querySelector('.cl-feature-more');
    if (more) { more.parentNode.removeChild(more); more = null; }

    // Caso especial: badge de firmeza reserva la 2ª línea.
    // Línea 1 = features normales (resto → "+"), línea 2 = firmeza.
    var firmeza = list.querySelector('.cl-feature-firmeza');
    if (firmeza) {
      var regulars = items.filter(function (li) { return li !== firmeza; });
      if (!regulars.length) return; // solo firmeza
      var firstTop = regulars[0].offsetTop;
      var hidden = false;
      regulars.forEach(function (li) {
        if (li.offsetTop !== firstTop) { li.style.display = 'none'; hidden = true; }
      });
      if (hidden) {
        more = document.createElement('li');
        more.className = 'cl-feature-more';
        more.textContent = '+';
        list.insertBefore(more, firmeza); // "+" al final de la línea 1 (antes de firmeza)
        var g = 0;
        while (more.offsetTop !== firstTop && g < 40) {
          var vis = regulars.filter(function (li) { return li.style.display !== 'none' && li.offsetTop === firstTop; });
          if (!vis.length) break;
          vis[vis.length - 1].style.display = 'none';
          g++;
        }
      }
      return;
    }

    if (items.length < 2) return;

    // ¿entra en 2 líneas? entonces no hace falta "+"
    if (distinctTops(items) <= 2) return;

    // hay 3+ líneas → agregar "+" y recortar desde el final hasta dejar 2 líneas (incluido el "+")
    more = document.createElement('li');
    more.className = 'cl-feature-more';
    more.textContent = '+';
    list.appendChild(more);

    var i = items.length - 1, guard = 0;
    while (i >= 0 && guard < 80 && distinctTops(items.concat(more)) > 2) {
      items[i].style.display = 'none';
      i--; guard++;
    }
  }

  function run() {
    var lists = document.querySelectorAll('.cl-feature-list');
    Array.prototype.forEach.call(lists, clamp);
  }

  // Fuerza object-fit:cover en la imagen de producto (gana a cualquier hoja CSS,
  // ya que en colección una regla cross-origin pone contain con más especificidad)
  function forceCover() {
    var imgs = document.querySelectorAll('.product-card-wrapper .card__media .media img');
    Array.prototype.forEach.call(imgs, function (img) {
      img.style.setProperty('object-fit', 'cover', 'important');
    });
  }

  // ===== Selector de variante: cambia precio / tachado / % / link en vivo =====
  var clSyncing = false;   // evita recursión al sincronizar la medida entre cards

  // Sincroniza la MISMA medida (texto del option) en TODAS las cards de la página que la tengan
  function syncMedidaAllCards(medida, source) {
    if (!medida) return;
    clSyncing = true;
    document.querySelectorAll('select.cl-variant-select').forEach(function (s) {
      if (s === source) return;
      for (var i = 0; i < s.options.length; i++) {
        if ((s.options[i].textContent || '').trim() === medida) {
          if (s.selectedIndex !== i) {
            s.selectedIndex = i;
            s.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    });
    clSyncing = false;
  }

  function onVariantChange(e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('cl-variant-select')) return;
    var card = sel.closest('.product-card-wrapper');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var price = opt.getAttribute('data-price');
    var compare = opt.getAttribute('data-compare');
    var disc = opt.getAttribute('data-discount');
    var url = opt.getAttribute('data-url');

    var priceWrap = card.querySelector('.cl-card-main-right .price');
    if (priceWrap) {
      var saleSpan = priceWrap.querySelector('.price__sale .price-item--sale');
      var regSpan = priceWrap.querySelector('.price__regular .price-item--regular');
      var sEl = priceWrap.querySelector('.price__sale s');
      if (compare) {
        priceWrap.classList.add('price--on-sale');
        if (saleSpan) saleSpan.textContent = price;
        if (sEl) sEl.textContent = compare;
      } else {
        priceWrap.classList.remove('price--on-sale');
        if (regSpan) regSpan.textContent = price;
      }
    }

    var discBadge = card.querySelector('.cl-badge-top--discount');
    if (discBadge) {
      if (compare && disc) {
        discBadge.style.display = '';
        var n = discBadge.querySelector('.cl-disc-num');
        if (n) n.textContent = disc + '%';
      } else {
        discBadge.style.display = 'none';
      }
    }

    if (url) {
      var link = card.querySelector('.cl-card-heading a');
      if (link) link.setAttribute('href', url);
    }

    // recalcular la financiación seQura para el precio de la variante elegida
    var fin = card.querySelector('.cl-card-finance[data-cl-finance]');
    var amt = opt.getAttribute('data-amount');
    if (fin && amt) { fin.setAttribute('data-amount', amt); updateFinance(fin); }

    // si lo cambió el usuario (no la sincronización), propagar la medida a TODAS las cards de la página
    if (!clSyncing) {
      var medidaTxt = opt ? (opt.textContent || '').trim() : '';
      try { if (medidaTxt) localStorage.setItem('cl_medida', medidaTxt); } catch (x) {}   // persistencia (este navegador)
      syncMedidaAllCards(medidaTxt, sel);
    }
  }

  // Reaplica la medida guardada (localStorage) a todas las cards al cargar / al añadir contenido async
  function restoreMedida() {
    var m = null;
    try { m = localStorage.getItem('cl_medida'); } catch (x) {}
    if (m) syncMedidaAllCards(m, null);
  }

  // ===== Financiación seQura: cuota "Desde X/mes" por card, calculada por el SDK de seQura
  // (programático, sin scrapear su DOM). DEFENSIVO: si seQura no está cargado / desactivado /
  // lanza error / el precio no llega al mínimo => no se muestra nada (la card queda sin esa fila). =====
  // Devuelve el "mejor" plan seQura (cuota total más baja) para un importe en céntimos.
  // El widget de seQura muestra instalment_total (cuota + comisión mensual), no instalment_amount.
  // DEFENSIVO: null si seQura no está cargado / desactivado / error / importe bajo el mínimo.
  function clFinanceBest(amountCents) {
    if (!amountCents || !window.Sequra || typeof Sequra.computeCreditAgreements !== 'function') return null;
    var res;
    try { res = Sequra.computeCreditAgreements({ product: 'pp3', amount: amountCents }); }
    catch (x) { return null; }
    if (!res || !res.pp3 || !res.pp3.length) return null; // sin agreements (p.ej. bajo el mínimo)
    var best = null;
    res.pp3.forEach(function (a) {
      var it = a && a.instalment_total;
      if (it && typeof it.value === 'number' && (best === null || it.value < best.instalment_total.value)) best = a;
    });
    return best;
  }

  function clFinanceText(amountCents) {
    var best = clFinanceBest(amountCents);
    return (best && best.instalment_total && best.instalment_total.string) ? best.instalment_total.string : null; // p.ej. "86,83 €"
  }

  // ===== Pill seQura CUSTOM de la PDP (.cl-sq-pill): cuota + nº de cuotas dinámicos por variante.
  // El "+info" es un .sequra-educational-popup que abre el popup educativo de seQura (lo liga su script). =====
  function pdpSqAmount(pill) {
    var prices = {};
    try { prices = JSON.parse(pill.getAttribute('data-prices') || '{}'); } catch (x) {}
    var idIn = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = idIn && idIn.value;
    if (id && prices[id] != null) return parseInt(prices[id], 10);
    return parseInt(pill.getAttribute('data-amount'), 10);
  }
  function updatePdpSqPill() {
    var pill = document.querySelector('.cl-sq-pill[data-amount]');
    if (!pill) return;
    var amount = pdpSqAmount(pill);
    var best = clFinanceBest(amount);
    var amtEl = pill.querySelector('.cl-sq-amount');
    var cntEl = pill.querySelector('.cl-sq-count');
    var info = pill.querySelector('.sequra-educational-popup');
    if (info && amount) info.setAttribute('data-amount', amount);
    if (best && best.instalment_total && best.instalment_total.string && amtEl) {
      // formatea como el widget: "111,00 €" => "111€", "86,83 €" => "86,83€"
      amtEl.textContent = best.instalment_total.string.replace(/ /g, ' ').replace(',00', '').replace(/\s+€/, '€');
      if (cntEl && best.instalment_count) cntEl.textContent = best.instalment_count; // p.ej. 12
      pill.classList.add('is-ready');
    } else {
      pill.classList.remove('is-ready'); // bajo mínimo / sin SDK => oculto (CSS)
    }
  }

  function updateFinance(el) {
    if (!el) return;
    var amount = parseInt(el.getAttribute('data-amount'), 10);
    var txt = el.querySelector('.cl-finance-text');
    var str = clFinanceText(amount);
    if (str && txt) {
      txt.textContent = 'Desde ' + str + '/mes';
      el.classList.add('is-ready');
    } else {
      el.classList.remove('is-ready'); // oculta de nuevo si no hay dato
    }
  }

  function updateAllFinance() {
    document.querySelectorAll('.cl-card-finance[data-cl-finance]').forEach(updateFinance);
    updatePdpSqPill();
  }

  // Arranca el SDK de seQura forzando la config de España, INDEPENDIENTE del país del visitante.
  // seQura keyea su arranque por Shopify.country (solo tiene "ES"), pero su `widgetData.ES`
  // (merchant/assetKey/cdn) viene incrustado en el loader para cualquier país. Lo usamos para
  // inyectar el SDK nosotros => la cuota se muestra a todos (el bloqueo a no-España ocurre al pagar).
  // No hardcodeamos merchant/assetKey: salen del loader y se auto-actualizan.
  function bootSequraSDK() {
    if (window.Sequra && typeof Sequra.computeCreditAgreements === 'function') return true; // ya cargado (p.ej. PDP)
    if (document.querySelector('script[data-cl-sequra]')) return true; // ya inyectado, esperando carga
    var wd = window.SequraWidgets && SequraWidgets.widgetData && SequraWidgets.widgetData.ES;
    if (!wd || !wd.cdnBaseUrl || !wd.merchantRef || !wd.assetSecret) return false; // loader aún no listo
    window.SequraConfiguration = {
      merchant: wd.merchantRef,
      assetKey: wd.assetSecret,
      products: (wd.paymentMethods || []).map(function (m) { return m.product; }),
      scriptUri: wd.cdnBaseUrl + '/assets/sequra-checkout.min.js',
      decimalSeparator: ',', thousandSeparator: '.', // formato ES
      locale: 'es-ES', currency: 'EUR'
    };
    window.SequraOnLoad = window.SequraOnLoad || [];
    window.Sequra = window.Sequra || {};
    if (typeof Sequra.onLoad !== 'function') Sequra.onLoad = function (cb) { window.SequraOnLoad.push(cb); };
    var s = document.createElement('script');
    s.async = 1; s.src = window.SequraConfiguration.scriptUri; s.setAttribute('data-cl-sequra', '1');
    document.head.appendChild(s);
    return true;
  }

  // Registra updateAllFinance vía Sequra.onLoad (dispara cuando el SDK cargó la tabla de cuotas).
  // DEFENSIVO: si en ~30s no aparece seQura (plugin ausente/desactivado), no mostramos nada.
  function initFinance() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      bootSequraSDK();
      if (window.Sequra && typeof Sequra.onLoad === 'function') {
        clearInterval(t);
        try { Sequra.onLoad(updateAllFinance); } catch (x) {}
        return;
      }
      if (tries > 60) clearInterval(t);
    }, 500);
  }

  // (Los swatches de color son nativos, renderizados en card-product.liquid desde
  // el metacampo custom.grupo_de_colores.)

  // carga las slides diferidas (2ª+) de un carrusel: data-src → src
  function loadCarouselSlides(track) {
    if (track.getAttribute('data-cl-loaded')) return;
    track.setAttribute('data-cl-loaded', '1');
    track.querySelectorAll('img.cl-lazy-slide[data-src]').forEach(function (img) {
      var ss = img.getAttribute('data-srcset');
      if (ss) img.setAttribute('srcset', ss);
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.classList.remove('cl-lazy-slide');
    });
  }

  // ===== Carrusel de imágenes de la card: drag con mouse (desktop). Móvil usa scroll-snap nativo.
  // Un drag NO debe navegar al producto; un click sí. =====
  function initCarousels() {
    var tracks = document.querySelectorAll('.cl-card-carousel:not([data-cl-carousel])');
    Array.prototype.forEach.call(tracks, function (track) {
      track.setAttribute('data-cl-carousel', '1');
      var down = false, startX = 0, startScroll = 0, moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return; // táctil = scroll nativo
        down = true; moved = false;
        startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (x) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        if (moved) {
          track.setAttribute('data-cl-dragged', '1');
          var w = track.clientWidth || 1;
          var idx = Math.round(track.scrollLeft / w);
          track.scrollTo({ left: idx * w, behavior: 'smooth' });
          setTimeout(function () { track.removeAttribute('data-cl-dragged'); }, 60);
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      // tras un drag, anular el click (evita navegar al producto)
      track.addEventListener('click', function (e) {
        if (track.getAttribute('data-cl-dragged')) { e.stopPropagation(); e.preventDefault(); }
      }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // aislar del slick padre (carrusel de la sección): no propagar los gestos del carrusel hijo
      ['mousedown', 'touchstart', 'touchmove', 'mousemove'].forEach(function (ev) {
        track.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });

      // cargar las imágenes diferidas en la primera interacción (hover/scroll/drag/touch)
      var load = function () { loadCarouselSlides(track); };
      ['pointerenter', 'pointerdown', 'touchstart', 'scroll', 'focusin'].forEach(function (ev) {
        track.addEventListener(ev, load, { once: true, passive: true });
      });

      // barra de progreso: mover el relleno según la slide activa
      var fill = track.parentElement && track.parentElement.querySelector('.cl-carousel-bar-fill');
      if (fill) {
        var updateBar = function () {
          var w = track.clientWidth || 1;
          var idx = Math.round(track.scrollLeft / w);
          fill.style.transform = 'translateX(' + (idx * 100) + '%)';
        };
        track.addEventListener('scroll', function () { window.requestAnimationFrame(updateBar); }, { passive: true });
        updateBar();
      }
    });
  }

  // "Guiño": la 1ª card de cada grid hace un peek (~30%) 2 veces para indicar que es carrusel.
  // Se detiene al interactuar. Una sola vez. Respeta prefers-reduced-motion.
  function playHint(track) {
    loadCarouselSlides(track); // necesita la 2ª imagen para el peek
    var w = track.clientWidth;
    if (!w) return;
    var peek = Math.round(w * 0.2);
    var cancelled = false, tmr;
    function cleanup() { ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.removeEventListener(ev, cancel); }); }
    function cancel() {
      if (cancelled) return;
      cancelled = true; clearTimeout(tmr);
      track.classList.remove('cl-hint-active');
      track.scrollTo({ left: 0, behavior: 'auto' });
      cleanup();
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, cancel, { once: true, passive: true }); });
    track.classList.add('cl-hint-active');
    var steps = [peek, 0, peek, 0];
    var i = 0;
    function step() {
      if (cancelled) return;
      if (i >= steps.length) { track.classList.remove('cl-hint-active'); cleanup(); return; }
      track.scrollTo({ left: steps[i], behavior: 'smooth' });
      i++; tmr = setTimeout(step, 600);
    }
    tmr = setTimeout(step, 650);
  }

  function playHints() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var grids = document.querySelectorAll('ul.product-grid, .product-grid');
    Array.prototype.forEach.call(grids, function (grid) {
      var track = grid.querySelector('.cl-card-carousel');
      if (!track || track.getAttribute('data-cl-hinted')) return;
      track.setAttribute('data-cl-hinted', '1');
      playHint(track);
    });
  }

  // ===== Galería de producto (PDP): barrita de avance + "guiño" en el slider móvil de Dawn,
  // con el mismo estilo que el carrusel de las cards. No toca la lógica nativa del slider. =====
  function playPdpHint(slider) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return; // solo móvil
    var w = slider.clientWidth;
    if (!w) return;
    var peek = Math.round(w * 0.18);
    var cancelled = false, tmr;
    function cleanup() { ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { slider.removeEventListener(ev, cancel); }); }
    function cancel() {
      if (cancelled) return;
      cancelled = true; clearTimeout(tmr);
      slider.scrollTo({ left: 0, behavior: 'auto' });
      cleanup();
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { slider.addEventListener(ev, cancel, { once: true, passive: true }); });
    var steps = [peek, 0, peek, 0], i = 0;
    function step() {
      if (cancelled) return;
      if (i >= steps.length) { cleanup(); return; }
      slider.scrollTo({ left: steps[i], behavior: 'smooth' });
      i++; tmr = setTimeout(step, 600);
    }
    tmr = setTimeout(step, 700);
  }

  function initPdpGallery() {
    var sliders = document.querySelectorAll('media-gallery .product__media-list.slider--mobile:not([data-cl-pdpbar])');
    Array.prototype.forEach.call(sliders, function (slider) {
      var items = slider.querySelectorAll('.product__media-item');
      if (items.length < 2) return;
      slider.setAttribute('data-cl-pdpbar', '1');

      // barrita de avance (dentro del slider-component, sobre la imagen, abajo)
      var sc = slider.closest('slider-component') || slider.parentNode;
      var bar = document.createElement('div');
      bar.className = 'cl-pdp-gallery-bar';
      bar.style.setProperty('--cl-slides', items.length);
      var fill = document.createElement('span');
      fill.className = 'cl-pdp-gallery-bar-fill';
      bar.appendChild(fill);
      sc.appendChild(bar);

      var update = function () {
        var w = slider.clientWidth || 1;
        var idx = Math.round(slider.scrollLeft / w);
        fill.style.transform = 'translateX(' + (idx * 100) + '%)';
      };
      slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();

      // ===== Arrastrar para deslizar (no abrir el zoom). Mouse: drag-scroll (solo en modo móvil <750).
      // Touch: swipe nativo + si hubo movimiento, anula el click que abriría el zoom. =====
      var down = false, startX = 0, startScroll = 0, moved = false;
      slider.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (window.innerWidth >= 750) return; // en desktop es cuadrícula, no carrusel
        down = true; moved = false;
        startX = e.clientX; startScroll = slider.scrollLeft;
        try { slider.setPointerCapture(e.pointerId); } catch (x) {}
      });
      slider.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        slider.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!down) return;
        down = false;
        if (moved) {
          slider.setAttribute('data-cl-dragged', '1');
          var w = slider.clientWidth || 1;
          slider.scrollTo({ left: Math.round(slider.scrollLeft / w) * w, behavior: 'smooth' });
          setTimeout(function () { slider.removeAttribute('data-cl-dragged'); }, 80);
        }
      }
      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);
      slider.addEventListener('pointerleave', endDrag);
      slider.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // touch: detectar swipe para anular el zoom
      var tx = 0, tMoved = false;
      slider.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; tMoved = false; }, { passive: true });
      slider.addEventListener('touchmove', function (e) { if (Math.abs(e.touches[0].clientX - tx) > 6) tMoved = true; }, { passive: true });
      slider.addEventListener('touchend', function () {
        if (tMoved) { slider.setAttribute('data-cl-dragged', '1'); setTimeout(function () { slider.removeAttribute('data-cl-dragged'); }, 120); }
      });

      // si hubo arrastre/swipe, no abrir el zoom (capturar el click antes que el botón de Dawn)
      slider.addEventListener('click', function (e) {
        if (slider.getAttribute('data-cl-dragged')) { e.stopPropagation(); e.preventDefault(); }
      }, true);

      playPdpHint(slider);
    });
  }

  var rafT;
  function runDebounced() { clearTimeout(rafT); rafT = setTimeout(run, 120); }
  var swT;
  function relocateDebounced() { clearTimeout(swT); swT = setTimeout(function () { initCarousels(); updateAllFinance(); restoreMedida(); }, 80); }

  // Drawer móvil: top = posición actual del header (debajo de la barra de anuncios; 0 si está scrolleado)
  function setDrawerTop() {
    var hw = document.querySelector('.header-wrapper');
    if (hw) document.documentElement.style.setProperty('--cl-drawer-top', Math.max(0, Math.round(hw.getBoundingClientRect().top)) + 'px');
  }

  // Megamenu desktop: abrir en HOVER (no en click). El click del título navega (es un <a>).
  function initMegaHover() {
    document.querySelectorAll('.header__inline-menu .mega-menu').forEach(function (d) {
      if (d.dataset.clHover) return;
      d.dataset.clHover = '1';
      var t;
      d.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        clearTimeout(t);
        document.querySelectorAll('.header__inline-menu .mega-menu[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        if (!d.hasAttribute('open')) d.setAttribute('open', '');
      });
      d.addEventListener('mouseleave', function () {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        clearTimeout(t);
        t = setTimeout(function () { d.removeAttribute('open'); }, 150);   // margen para cruzar el hueco summary->panel
      });
    });
  }

  function init() {
    forceCover();
    run();
    initCarousels();
    initFinance();
    initPdpGallery();
    setDrawerTop();
    initMegaHover();
    var mSum = document.querySelector('.header__icon--menu');
    if (mSum) mSum.addEventListener('click', setDrawerTop);
    window.addEventListener('resize', setDrawerTop);
    document.addEventListener('change', onVariantChange);
    // PDP: recalcular el pill seQura custom al cambiar de variante (input oculto [name="id"])
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') updatePdpSqPill(); });

    restoreMedida();   // re-aplicar la medida guardada (persistencia por navegador)

    // El card__inner quedó por encima del overlay del link (para que el dropdown sea clickable);
    // restauramos el click en la imagen → ir al producto, excepto dropdown y swatches de color.
    document.addEventListener('click', function (e) {
      var media = e.target.closest && e.target.closest('.product-card-wrapper .card__media');
      if (!media) return;
      if (e.target.closest('.cl-variant-select-wrap')) return; // selector de medidas
      if (e.target.closest('.cl-color-swatches')) return; // círculo de color (tiene su propio link)
      var card = media.closest('.product-card-wrapper');
      var link = card && card.querySelector('.cl-card-heading a');
      if (link && link.href) window.location.href = link.href;
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    // recalcular cuando cambia el ancho de cada lista (cambio de columnas / viewport / zoom)
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(runDebounced);
      document.querySelectorAll('.cl-feature-list').forEach(function (l) { ro.observe(l); });
    }
    // contenido async (slick clona cards, secciones que cargan tarde) → re-init carrusel/financiación
    if (window.MutationObserver) {
      var mo = new MutationObserver(relocateDebounced);
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('load', function () { forceCover(); run(); initCarousels(); playHints(); initPdpGallery(); });
  window.addEventListener('resize', runDebounced);
  window.clCardClamp = run;
})();
